export default __webpack_public_path__ + "static/media/icon-home-update-hover.d3336561.svg";